import { Component, inject } from "@angular/core"
import { PurchasingCoOpNavigationComponent } from "./purchasingCoOpNavigation.component"
import { RouteService } from "@services/route.service"
import { MembershipNavigationComponent } from "./membershipNavigation.component"

@Component({
    selector: 'vco-navigation',
    imports: [PurchasingCoOpNavigationComponent, MembershipNavigationComponent],
    template: ` 
        <nav>
            @if(route().purchasingCoOp) {
                <vco-purchasing-co-op-navigation class="nav-group"></vco-purchasing-co-op-navigation>
            }
            @if(route().membership) {
                <vco-membership-navigation class="nav-group"></vco-membership-navigation>
            }
        </nav>
    `,
    styles: [`
        .nav-group {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
        }
    `]
}) export class NavigationComponent {
    private readonly _routeService = inject(RouteService)
    readonly route = this._routeService.currentRoute
}